import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

/**
 * Swing Trap Behavior - Pendulum motion, swinging back and forth
 * Rotates around specified axis with sinusoidal motion
 */

export class ObstacleSwingBehavior extends ObstacleBehavior {
  private time: number = 0;

  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstacleSwing', startPosition, pathIndex, config);
  }

  update(deltaTime: number): void {
    this.time += deltaTime * this.config.speed;

    // Sinusoidal pendulum motion
    const angle = Math.sin(this.time) * this.config.angle;

    // Clear any quaternion rotation
    if (this.mesh.rotationQuaternion) {
      this.mesh.rotationQuaternion = null;
    }

    // Apply rotation on specified axis
    switch (this.config.axis) {
      case 'x':
        this.mesh.rotation.x = this.startRotation.x + angle;
        this.mesh.rotation.y = this.startRotation.y;
        this.mesh.rotation.z = this.startRotation.z;
        break;
      case 'y':
        this.mesh.rotation.x = this.startRotation.x;
        this.mesh.rotation.y = this.startRotation.y + angle;
        this.mesh.rotation.z = this.startRotation.z;
        break;
      case 'z':
        this.mesh.rotation.x = this.startRotation.x;
        this.mesh.rotation.y = this.startRotation.y;
        this.mesh.rotation.z = this.startRotation.z + angle;
        break;
    }
  }

  clone(): ObstacleSwingBehavior {
    return new ObstacleSwingBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
